<div class="resource-header" [class.resource-header--no-margin-bottom]="!headerMarginBottom">
  <!-- Primary Logo -->
  <div *ngIf="logoUrl" class="resource-logo">
    <img class="resource-logo-image" [src]="logoUrl" [alt]="logoAlterativeText" />
  </div>

  <!-- Secondary Logo -->
  <div *ngIf="secondaryLogoUrl" class="resource-logo">
    <img class="resource-logo-image" [src]="secondaryLogoUrl" [alt]="secondaryLogoAlternativeText" />
  </div>
</div>

<div class="resource-container" [class.resource-container--no-padding]="!contentPadding">
  <ng-content select="[resource-content]"></ng-content>
</div>

<div class="resource-footer">
  <div class="row">
    <app-site-disclaimer class="col-12" [disclaimerConfig]="headerFooterDisclaimerText"></app-site-disclaimer>
  </div>

  <div *ngIf="showCopyright" class="row">
    <app-copyright class="col-12" [copyright]="copyright"></app-copyright>
  </div>

  <div *ngIf="footerCMSEnabled" class="row">
    <app-cms-approval-code
      class="col-12"
      [showMainCMS]="footerCMSEnabled"
      [CMS]="cmsApprovalCode"
      [showLastUpdated]="showLastUpdated"
      [lastUpdatedLabel]="lastUpdatedLabel"
    ></app-cms-approval-code>
  </div>

  <app-logo
    [logoConfig]="footerLogoProperties"
    [contentServerUrl]="contentServerUrl"
    [footerLogoAlternateText]="footerLogoAlternateText"
  ></app-logo>
</div>
